import { useNavigate, useParams } from 'react-router-dom'

import { CreateTrainingFileMutationVariables } from 'generated/resources/graphql'
import {
  NewMaterialFileDocument,
  TrainingDetailMaterialsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import { FileSubmissionData } from 'modules/trainings/components/Files/NewFileModal/types'

export default function TrainingMaterialsNewFileModal() {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [createTrainingFile] = useMutation(NewMaterialFileDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingFile,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingDetailMaterialsDocument],
  })

  function navigateBack() {
    navigate(navigation.trainings.list.details_revamp.view.attachments.fullPath({ id: Number(id) }))
  }

  const handleSubmit = async (data: FileSubmissionData) => {
    const variables: CreateTrainingFileMutationVariables = {
      trainingId: Number(id),
      authorId: data.authorId,
      title: data.title,
    }
    if (data.type === 'signedId' && data.signedId) {
      variables.signedId = data.signedId
    } else if (data.type === 'file') {
      variables.file = data.file
    } else {
      throw new Error('Either file or signedId must be provided')
    }
    const result = await createTrainingFile({
      variables,
    })
    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_files_modal.create_error'),
      })
    })
    if (handled.success) {
      navigateBack()
    }
  }

  return (
    <NewFileModal
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.materials.new_file_modal.description'
      )}
      onClose={navigateBack}
      onSubmit={handleSubmit}
      resourceId={id}
      resourceType="Trainings::Training"
      title={i18n.t('trainings.trainings_revamp.training_detail.materials.new_file_modal.title')}
    />
  )
}
